<template>
    <v-sheet>
        <template v-if="items?.length">
            <v-data-table v-bind="{ items, headers }" disable-filtering disable-pagination disable-sort hide-default-footer :mobile-breakpoint="$vuetify.breakpoint.thresholds.sm">
                <template v-for="header in headers.filter((header) => header.hasOwnProperty('formatter'))" #[`item.${header.value}`]="{ value }"> {{ header.formatter(value) }} </template>
            </v-data-table>
            <v-pagination v-model="page" :length="pageCount" total-visible="11" color="primary" @input="search" />
        </template>
        <template v-else>
            <p class="page-text grey-6--text text-center">
                안녕하세요, 담당자님. <br />
                무통장입금 거래 내역이 없습니다.
            </p>
        </template>
    </v-sheet>
</template>

<script>
import api from "@/api";

const code = "point-order-account";

const headers = [
    { width: 164, text: "주문일시", value: "createdAt", formatter: (value) => value?.toDateTime?.() || value || "-" },
    { width: 120, text: "입금자명", value: "meta.sender" },
    { width: 120, text: "결제금액", value: "meta.amount", formatter: (value) => (value?.format?.() || 0) + "원" },
    { width: 120, text: "상태", value: "stateText" },
    {
        width: 120,
        text: "입금계좌",
        value: "meta.bank",
        formatter: ({ name, accountHolder, accountNumber } = {}) => {
            let text = "";
            if (name) text += name;
            if (accountHolder) {
                if (text) text += " / ";
                text += accountHolder;
            }
            if (accountNumber) {
                if (text) text += "\n";
                text += accountNumber;
            }
            return text;
            // return [name, accountHolder, accountNumber].filter((item) => item).join("\n");
        },
        cellClass: "white-space-pre-line",
    },
].map((item) => ({ ...item, formatter: item.formatter ?? ((value) => value ?? "-") }));

export default {
    data: () => ({
        forms: [],

        page: 1,
        limit: 10,
        summary: { totalCount: 0 },

        headers,

        loading: false,
    }),
    computed: {
        items() {
            return [...this.forms];
        },
        skip() {
            return (this.page - 1) * this.limit;
        },
        pageCount() {
            return Math.ceil(this.summary.totalCount / this.limit) || 1;
        },
        params() {
            return { code, isMine: true };
        },
    },
    mounted() {
        this.search();
    },
    methods: {
        async search() {
            if (this.loading) return;
            else this.loading = true;

            try {
                const { skip, limit, params } = this;
                const { summary, forms } = await api.v1.forms.gets({
                    headers: { skip, limit },
                    params,
                });

                this.forms = forms;
                this.summary = summary;
            } finally {
                this.loading = false;
            }
        },
    },
};
</script>

<style lang="scss" scoped>
::v-deep {
    .white-space-pre-line {
        white-space: pre-line;
    }
}
</style>